import Select from 'react-select';
import { Box } from '@mui/material';
import { Controller } from 'react-hook-form';
import { CustomOption } from './customOption';
import CustomLabel from 'components/customLabel';
import ErrorMessage from 'components/errorMessage';

type Props = {
  errors: any;
  control: any;
  search?: any;
  name: string;
  label: string;
  isMulti?: boolean;
  loading?: boolean;
  handleChange?: any;
  custoName?: string;
  required?: boolean;
  options?: Object[];
  disabled?: boolean;
  isSearchable?: boolean;
  setSearch?: (e: any) => void;
};

export default function ReactSelect({
  name,
  label,
  search,
  errors,
  control,
  options,
  loading,
  required,
  setSearch,
  custoName,
  handleChange,
  isMulti = false,
  disabled = false,
  isSearchable = true,
}: Props) {
  const colourStyles = {
    control: (provided: any) => ({
      ...provided,
      minHeight: '40px',
      border: errors?.[name]?.type === 'required' ? '1px solid #D32F2F' : '1px solid #C4c4c4',
    }),

    multiValue: (styles: any) => {
      return {
        ...styles,
        padding: '5px',
        backgroundColor: '#F3F8FC',
        border: '1px solid #187CD3',
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        margin: '4px 4px',
      };
    },
    multiValueLabel: (styles: any) => ({
      ...styles,
      color: '#187CD3',
      fontSize: '12px',
      lineHeight: '14px',
    }),
    multiValueRemove: (styles: any) => ({
      ...styles,
      padding: 0,
      justfyContent: 'center',
      alignItem: 'center',
      width: '16px',
      height: '16px',
      background: '#F3F8FC',
      border: '1px solid #187CD3',
      borderRadius: '50px',
      color: '#187CD3',
      marginLeft: '5px',

      ':hover': {
        background: '#F3F8FC',
        border: '1px solid #187CD3',
        borderRadius: '50px',
      },
    }),
  };

  const handleKeyDown = (e: any) => {
    if (e.key === 'Escape') {
      return;
    }
  };

  const handeleSearch = (e: any, value: any) => {
    if (value.action !== 'input-change') {
      return;
    }

    setSearch?.({ ...(search || {}), [custoName ? custoName : name]: e });
  };

  return (
    <Box width='100%' position='relative'>
      <CustomLabel>{label}</CustomLabel>
      <Box mt='5px' />
      <Controller
        name={name}
        control={control}
        rules={{
          required: required && 'Поле, обязательное для заполнения',
        }}
        render={({ field }) => (
          <Select
            {...field}
            placeholder=''
            options={options}
            isMulti={isMulti}
            isLoading={loading}
            value={field.value}
            menuPosition='fixed'
            styles={colourStyles}
            isDisabled={disabled}
            onKeyDown={handleKeyDown}
            isSearchable={isSearchable}
            closeMenuOnSelect={!isMulti}
            onInputChange={isSearchable ? handeleSearch : undefined}
            // isClearable={!isMulti}
            onChange={(event, b) => {
              field.onChange(event);
              handleChange?.();
            }}
            components={{
              Option: CustomOption,
              IndicatorSeparator: () => null,
            }}
          />
        )}
      />
      <span style={{ color: 'red', fontSize: '12px', position: 'absolute', left: 0, bottom: -15 }}>
        {errors?.type === 'required' && errors?.message}
      </span>
      <ErrorMessage error={errors} name={name} />
    </Box>
  );
}
